<template>
  <div>
    <Header />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <main class="app-content">
      
      <h52>
        <span
          class="txt-rotate2"
          data-period="4000"
          data-rotate2='[ "ASLAN ENERGY MADENCİLİK", "MUSTAFA ASLAN"]'
        ></span>
      </h52>
    </main>

    <Sidebar />
  </div>
</template>

<script>
let TxtRotate = function(el, toRotate2, period) {
  this.toRotate2 = toRotate2;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = "";
  this.tick();
  this.isDeleting = false;
};

TxtRotate.prototype.tick = function() {
  let i = this.loopNum % this.toRotate2.length;
  let fullTxt = this.toRotate2[i];

  if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1);
  } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1);
  }

  this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

  let that = this;
  let delta = 300 - Math.random() * 100;

  if (this.isDeleting) {
    delta /= 2;
  }

  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
  } else if (this.isDeleting && this.txt === "") {
    this.isDeleting = false;
    this.loopNum++;
    delta = 500;
  }

  setTimeout(function() {
    that.tick();
  }, delta);
};

window.onload = function() {
  let elements = document.getElementsByClassName("txt-rotate2");
  for (let i = 0; i < elements.length; i++) {
    let toRotate2 = elements[i].getAttribute("data-rotate2");
    let period = elements[i].getAttribute("data-period");
    if (toRotate2) {
      new TxtRotate(elements[i], JSON.parse(toRotate2), period);
    }
  }
};
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: {
        filehead: "",
        classNum: "",
        filecontent: "",
        deneme1: "",
        deneme2: "",
        deneme3: "",
      },
      file: "",
      fileWarn: "",
      product: {
        selectedImage: null,
      },
      jobTitles: [],
    };
  },

  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    controller() {
      if (!this.$refs.file.files[0]) {
        this.$swal({
          text: "Yüklemek istediğiniz dosyayı seçiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
      } else if (this.result.classNum < 1) {
        this.$swal({
          text: "Lütfen notun kaçıncı sınıfa ait olduğunu belirtiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
      } else if (this.result.filecontent.length <= 1) {
        this.$swal({
          text: "Lütfen dosya içeriğini belirtiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
      } else {
        this.uploadFile();
      }
    },
    onChange(e) {
      const file = e.target.files[0];
      document.getElementById("filename").innerHTML = file.name;
      this.result.filehead = file.name;
    },
    onChangeDrop(e) {
      const file = e.target.value;
      this.result.classNum = file;
    },

    reload: function() {
      location.reload();
    },

    uploadFile: function() {
      this.file = this.$refs.file.files[0];
      if (!this.$refs.file.files[0]) {
        this.$swal({
          text: "Lütfen yüklemek istediğiniz dosyayı seçiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
        // return this.sendData();
      }
      if (this.file.size > 10000000) {
        this.$swal({
          text: "Yüklemek İstediğiniz Dosyanın Boyutu 10 MB'yi geçemez!",
          icon: "error",
          closeOnClickOutside: false,
        });
        //console.log("dosya boyutu büyük");
        return;
      }
      var sendData = this.sendData;

      let formData = new FormData();
      formData.append("file", this.file);
      var token = localStorage.getItem("token");
      var query = store.state.pdf_upload_url + "?token=" + token;
      axios
        .post(query, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          if (response.data.result) {
            sendData(response.data.data);
          }
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    sendData: function(pathname) {
      var url = store.state.base_url + "User/userUploadFile.php?key=123";
      var datas = {
        token: localStorage.getItem("token"),
        sectionsId: localStorage.getItem("sectionsId"),
        id: localStorage.getItem("id"),
        pathname: pathname,
        filehead: this.result.filehead.toLowerCase(),
        filecontent: this.result.filecontent.toLowerCase(),
        classNum: this.result.classNum,
      };
      console.log(this.result.filecontent);
      console.log(this.result.classNum);

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.result == true) {
            this.$swal({
              text: "Yükleme İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: false,
            });
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Homepage.vue